import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Image = ({ slice }) => {
  if (!slice.primary.image.gatsbyImageData) return null
  return (
    <section className='component-image mx-auto max-w-screen-xl p-6'>
      <div className='mx-auto w-full bg-white text-center'>
        <GatsbyImage image={slice.primary.image.gatsbyImageData} alt={slice.primary.image.alt || ''} />
      </div>
    </section>
  )
}

export default Image
